import axios from "axios";
import { STORAGE_KEYS } from "./constants";
import { API_BASE_URL } from "./localOrigin";

// denzo-api's ApiResponse() always answers with the HTTP status literally
// equal to $this->response['status'] (200/401/404/405/409/412/422/423) — see
// CustomHelpers::ApiResponse — so these interceptors can rely on real HTTP
// status codes exactly like denzo-waiter's own http.js does.
const handleError = (error) => {
  let err = { status: 500, message: "Something went wrong, please try again" };
  if (error.response) {
    err = {
      status: error.response.status,
      message: error.response.data?.message || "Something went wrong, please try again",
    };
    if (err.status === 401) {
      // No login screen to bounce to here — this app never logs in, it just
      // registers an anonymous guest token. Dropping the stale token and
      // reloading lets SessionContext's init effect register a fresh one,
      // matching denzo-web's own 401 handling (App.js/http.js).
      localStorage.removeItem(STORAGE_KEYS.token);
      localStorage.removeItem(STORAGE_KEYS.user);
      window.location.reload();
    } else if (err.status === 422) {
      err.errors = error.response.data?.errors;
    }
  }
  return Promise.reject(err);
};

const REQUEST_TIMEOUT_MS = 15000;

const baseURL = API_BASE_URL;

// Bearer-authenticated client, used for every call once the anonymous guest
// token from POST register exists (products, product details, cart, orders).
export const apiClient = axios.create({
  baseURL,
  headers: { Accept: "application/json" },
  timeout: REQUEST_TIMEOUT_MS,
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem(STORAGE_KEYS.token);
  if (token) config.headers.Authorization = `Bearer ${JSON.parse(token)}`;
  return config;
});

apiClient.interceptors.response.use((res) => res, handleError);

// No-auth client — get-store (resolve the store from this deployment's
// domain) and register (mint the anonymous guest token) both run before any
// token exists.
export const apiAuth = axios.create({
  baseURL,
  headers: { Accept: "application/json" },
  timeout: REQUEST_TIMEOUT_MS,
});

apiAuth.interceptors.response.use((res) => res, handleError);
